const NAV_SECTION_MAP = Object.freeze({
  specialCategory: {
    sectionKey: "specialCategorySection",
    colorsKey: "specialCategoryColors",
  },
  categories: {
    sectionKey: "categorySection",
    colorsKey: "categoryColors",
  },
  latest: {
    sectionKey: "latestSection",
    colorsKey: "latestColors",
  },
  updates: {
    sectionKey: "updatesSection",
    colorsKey: "updatesColors",
  },
});

const resolveSectionKindFromEntity = (entity) => {
  if (!entity) return null;
  if (entity.specialCategory) return "specialCategory";
  if (entity.categoryGrid) return "categories";
  if (entity.latestCategory) return "latest";
  if (entity.updatesCategory) return "updates";
  return null;
};

export const resolveNavSectionKind = (group, item) =>
  resolveSectionKindFromEntity(item) ||
  resolveSectionKindFromEntity(group) ||
  null;

export const getSectionStyles = (sectionData, fontStyles, sectionColors) => {
  if (!fontStyles) return {};

  const styles = {};
  const useSectionColors = sectionData?.useSectionColors !== false;
  const useSectionFontSizes = sectionData?.useSectionFontSizes === true;

  if (fontStyles.heading) styles.headingFont = fontStyles.heading;
  if (fontStyles.subHeading) styles.subHeadingFont = fontStyles.subHeading;
  if (fontStyles.content) styles.contentFont = fontStyles.content;
  if (fontStyles.button) styles.buttonFont = fontStyles.button;
  if (fontStyles.stats) styles.statsFont = fontStyles.stats;

  if (useSectionFontSizes && sectionData?.fontSizes) {
    styles.fontSizes = { ...sectionData.fontSizes };
  }

  if (useSectionColors && sectionColors) {
    styles.headingColor = sectionColors.headingColor || fontStyles.heading?.color;
    styles.subHeadingColor =
      sectionColors.subHeadingColor || fontStyles.subHeading?.color;
    styles.contentColor = sectionColors.contentColor || fontStyles.content?.color;
    styles.buttonTextColor =
      sectionColors.buttonTextColor || fontStyles.button?.color;
    styles.buttonBgColor = sectionColors.buttonBgColor;
    if (sectionColors.statsColor) styles.statsColor = sectionColors.statsColor;
    if (sectionColors.iconColor) styles.iconColor = sectionColors.iconColor;
    if (sectionColors.ratingColor) styles.ratingColor = sectionColors.ratingColor;
    if (sectionColors.serviceTitleColor) {
      styles.serviceTitleColor = sectionColors.serviceTitleColor;
    }
    if (sectionColors.serviceContentColor) {
      styles.serviceContentColor = sectionColors.serviceContentColor;
    }
    if (sectionColors.reviewerNameColor) {
      styles.reviewerNameColor = sectionColors.reviewerNameColor;
    }
    if (sectionColors.reviewerDesignationColor) {
      styles.reviewerDesignationColor = sectionColors.reviewerDesignationColor;
    }
    if (sectionColors.numberColor) styles.numberColor = sectionColors.numberColor;
    if (sectionColors.cardBgColor) styles.cardBgColor = sectionColors.cardBgColor;
  } else {
    styles.headingColor = fontStyles.heading?.color;
    styles.subHeadingColor = fontStyles.subHeading?.color;
    styles.contentColor = fontStyles.content?.color;
    styles.buttonTextColor = fontStyles.button?.color;
    styles.buttonBgColor = fontStyles.button?.backgroundColor;
    styles.statsColor = fontStyles.stats?.color;
  }

  return styles;
};

export const getNavSectionStyles = (homepageCfg, group, item) => {
  const fontStyles = homepageCfg?.fontStyles || {};
  const sectionKind = resolveNavSectionKind(group, item);
  const sectionLookup = sectionKind ? NAV_SECTION_MAP[sectionKind] : null;
  const sectionData = sectionLookup
    ? homepageCfg?.[sectionLookup.sectionKey]
    : undefined;
  const sectionColors = sectionLookup
    ? homepageCfg?.[sectionLookup.colorsKey]
    : undefined;

  return {
    sectionKind,
    fontStyles,
    sectionStyles: getSectionStyles(sectionData, fontStyles, sectionColors),
  };
};
